<template>
  <div>
    <div class="h2">
      Autres personnes à assurer
    </div>

    <input-checkbox-simple
      label="Souhaitez-vous assurer votre conjoint ?"
      slug="conjoint"
      :model="conjoint"
      :true-value="'1'"
      :false-value="'2'"
      :v$="v$"
      @change-value="$emit('update:conjoint', $event)"
    />

    <input-select
      label="Nombre d'enfants de moins de 20 ans à assurer"
      slug="nbEnfants"
      :model="nbEnfants"
      :options="nbEnfantsOptions"
      :v$="v$"
      @input="$emit('update:nbEnfants', $event.target.value)"
    />
  </div>
</template>

<script>
import InputCheckboxSimple from "src/modules/shared/components/Form/InputCheckboxSimple";
import InputSelect from "src/modules/shared/components/Form/InputSelect";
import {computed} from "vue";
import useVuelidate from "@vuelidate/core";
import {required, serverError} from "src/modules/shared/validators/validators";

export default {
  name: "OtherPersonalInformationForm",
  components: {
    InputCheckboxSimple,
    InputSelect
  },
  props: {
    serverErrors: {
      type: Array,
      required: true
    },
    conjoint: {
      type: String,
      default: ''
    },
    nbEnfants: {
      type: String,
      default: ''
    },
    nbEnfantsOptions: {
      type: Array,
      required: true
    }
  },
  emits: [
    'update:conjoint',
    'update:nbEnfants'
  ],
  setup (props) {
    const validations = computed(() => ({
      conjoint: {
        required,
        serverError: serverError(props, 'conjoint')
      },
      nbEnfants: {
        required,
        serverError: serverError(props, 'nbEnfants')
      },
    }))

    const v$ = useVuelidate(validations, props)

    return { v$ }
  },
  watch: {
    serverErrors () {
      this.v$.$reset()
      this.v$.$touch()
    }
  }
}
</script>

<style scoped>

</style>
